import React from "react";

import { AvgVideoUploadTimeGraphData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgVideoUploadTime/AvgVideoUploadTimeGraphData";
import { AvgVideoUploadTimeRawData } from "@pages/VideoAnalytics/RBTs/GraphAndrawData/AvgVideoUploadTime/AvgVideoUploadTimeRawData";
import { useVideoAnalytics } from "@providers/VideoAnalyticsProvider";

interface AvgVideoUploadTimeProps {}

export const AvgVideoUploadTime: React.FC<AvgVideoUploadTimeProps> = () => {
  const { selectedDialogTab } = useVideoAnalytics();
  return (
    <div>{selectedDialogTab === "Raw Data" ? <AvgVideoUploadTimeRawData /> : <AvgVideoUploadTimeGraphData />}</div>
  );
};
